import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { NewsTypeEnum } from 'APIPackage/NewsModule/enums/NewsTypeEnum';

export const newsTypeOptions: ISelectOption[] = [
  {
    id: NewsTypeEnum.NEWS,
    label: 'Новость',
    value: NewsTypeEnum.NEWS,
  },
  {
    id: NewsTypeEnum.ANNOUNCEMENT,
    label: 'Анонс',
    value: NewsTypeEnum.ANNOUNCEMENT,
  },
];
